import { For, Show, useContext, type JSX } from 'solid-js';
import { AppContext } from '../../../app-context-provider/app-context-provider';
import { Specification } from '../product-types';
import { ProductSpecificationProps } from './product-specifications-types';
import { AddToBasketButton } from '../../basket/basket-components';

const Field = (props: { label: string; value?: JSX.Element | string; class?: string }) => (
    <div class={`flex flex-col gap-cvi-2 min-w-0 ${props.class ?? ''}`}>
        <span class="body-xs font-cvi-bold text-cvi-fg-default break-words">{props.label}</span>
        <span class="body-sm font-cvi-regular text-cvi-fg-default break-words">{props.value}</span>
    </div>
);

export const ProductSpecificationsMobile = (props: ProductSpecificationProps) => {
    const { localize, siteInfo } = useContext(AppContext);

    const isCareSite = () => siteInfo.siteType === 'atos-care';

    return (
        <div class="flex flex-col gap-cvi-6">
            <For each={props.product.specifications}>
                {(spec: Specification) => (
                    <div class="rounded-cvi-md bg-cvi-bg-neutral-subtle p-cvi-6 flex flex-col gap-cvi-6">
                        <Field label={localize('name', 'Name')} value={spec?.name} />
                        <Field label={localize('description', 'Description')} value={spec?.description} />
                        <div class="grid grid-cols-2 gap-cvi-6">
                            <Field label={localize('ref-nr', 'Reference number')} value={spec?.refNumber} />
                            <Field label={localize('quantity', 'Quantity')} value={spec?.quantity} />
                        </div>
                        <Show when={isCareSite()}>
                            <div class="flex">
                                <AddToBasketButton product={props.product} specification={spec} />
                            </div>
                        </Show>
                    </div>
                )}
            </For>
        </div>
    );
};
